import gql from 'graphql-tag'
import client from '@stores/apollo'

type Units = 'sqft' | 'sqm'

export function updateContext(userId: string, context: any): Promise<string> {
  const variables = {
    input: {
      id: userId,
      context: JSON.stringify(context),
    },
  }
  return client.gql.mutate({ mutation, variables }).then(
    ({
      data: {
        updateUser: {
          user: { id },
        },
      },
    }: any) => id
  )
}

export function updateUnits(userId: string, units: Units) {
  return updateContext(userId, { units })
}

interface IUpdateAuthAppProps {
  otpSecretKey?: string
  otp?: string
  password?: string
}
interface IUpdateAuthAppPayload {
  status: string
  otpSecretKey: string
}
export function updateAuthApp({
  otpSecretKey,
  otp,
  password,
}: IUpdateAuthAppProps): Promise<IUpdateAuthAppPayload> {
  const variables = {
    input: {
      otpSecretKey,
      otp,
      password,
    },
  }
  return client.gql
    .mutate({ mutation: authMutation, variables })
    .then(({ data: { updateEmployeeAuthApp } }: any) => updateEmployeeAuthApp)
}

const mutation = gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      user {
        id
      }
    }
  }
`
const authMutation = gql`
  mutation UpdateEmployeeAuthApp($input: UpdateEmployeeAuthAppInput!) {
    updateEmployeeAuthApp(input: $input) {
      status
      otpSecretKey
    }
  }
`
